import { AccordionDetails, AccordionSummary, Box, Stack } from '@mui/material';
import RichText from '../../../RichText';
import FaqAccordion from './FaqAccordion';
import { AccordionType } from '../type';
import DarkThemeProvider from '../../../../providers/DarkThemeProvider';
import LightThemeProvider from '../../../../providers/LightThemeProvider';
import TbIcon from '../../../elements/TbIcon';
import { ExpandMore } from '@mui/icons-material';

type Props = {
  data: AccordionType;
};

const StandardAccordion = ({ data }: Props) => {
  const { elements, styling, icon } = data;
  const ThemeProvider = styling.isDark ? DarkThemeProvider : LightThemeProvider;
  return (
    <ThemeProvider>
      <Stack
        className={'tb-accordion-standard'}
        sx={{
          borderRadius: { xs: 0.5, md: 1 },
          alignItems: 'center',
          justifyContent: 'center',
          color: 'text.primary',
          ...styling.sx,
        }}
      >
        <Box
          sx={{
            maxWidth: 'md',
            bgcolor: 'background.paper',
            borderRadius: 'inherit',
            p: { xs: 2, md: 4 },
          }}
        >
          {elements.map((faq, index) => {
            return (
              <FaqAccordion key={index} question={faq.title}>
                <AccordionSummary
                  expandIcon={
                    icon ? (
                      <TbIcon
                        icon={icon}
                        size={24}
                        className={'tb-accordion-standard-icon'}
                      />
                    ) : (
                      <ExpandMore />
                    )
                  }
                >
                  <RichText
                    withTypography
                    variant={'subtitle2'}
                    component={'span'}
                    color={'textPrimary'}
                  >
                    {faq.title}
                  </RichText>
                </AccordionSummary>
                <AccordionDetails sx={{ color: 'text.secondary' }}>
                  <RichText>{faq.description}</RichText>
                </AccordionDetails>
              </FaqAccordion>
            );
          })}
        </Box>
      </Stack>
    </ThemeProvider>
  );
};

export default StandardAccordion;
